/**
 * Hook for calculating roster statistics
 * Computes stats from existing user data to avoid additional API calls
 */

import { useMemo } from 'react'
import { LightweightUser } from 'src/v3/manage/manage.slice'

interface UseRosterStatsProps {
  users: LightweightUser[]
  isLoading: boolean
}

interface RosterStats {
  totalUsers: number
  usersNotLoggedIn: number
}

export function useRosterStats({ users, isLoading }: UseRosterStatsProps) {
  let stats = useMemo((): RosterStats => {
    if (!users || users.length === 0) {
      return {
        totalUsers: 0,
        usersNotLoggedIn: 0,
      }
    }

    let totalUsers = users.length

    // Count users who haven't logged in yet (show up with "Unknown" names)
    let usersNotLoggedIn = users.filter((user) => {
      let firstName = user.firstName || ''
      let lastName = user.lastName || ''

      // Users who haven't logged in typically have "Unknown" as first/last name
      // or empty/missing names
      return (
        firstName === 'Unknown' ||
        lastName === 'Unknown' ||
        (firstName.trim() === '' && lastName.trim() === '')
      )
    }).length

    return {
      totalUsers,
      usersNotLoggedIn,
    }
  }, [users])

  return {
    ...stats,
    isLoading,
  }
}
